import { Components, Theme } from '@mui/material/styles';

export const tooltipThemeDefinition = () =>
  ({
    MuiTooltip: {
      defaultProps: {
        arrow: true,
        enterDelay: 1000,
        disableInteractive: true,
      },
      styleOverrides: {
        root: {},
      },
    },
  } as Components<Theme>);
